import styled from "styled-components";
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
  FONT_FAMILY,
} from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const PartnersContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
  scroll-margin-top: var(--navigation-offset, 120px);
`;

export const TitleSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const HeaderSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};
  padding-block: 0 24px;

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: 0;
  }
`;

export const ContentSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const SearchToolbar = styled.div<{ $biggerCursor: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  form { flex: 1; min-width: 0; }
  input { min-width: 0; }
  button { cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"}; }
  @media (max-width: 767px) {
    form { flex-basis: 100%; }
  }
`;

export const ToolbarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: 0;
  border-radius: 24px;
  background: ${COLORS.Cultured};
  color: ${COLORS.RaisinBlack};
  font-family: ${FONT_FAMILY.poppins};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover { background: ${COLORS.Background}; }
  &:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 2px; }
`;

export const SortButton = styled(ToolbarButton)`
  min-height: 56px;
  @media (max-width: 767px) { min-height: 40px; margin-left: auto; }
`;

export const ResultsCount = styled.div`
  flex-basis: 100%;
  order: 3;
  @media (max-width: 767px) { flex-basis: auto; order: 0; }
`;

export const BackToWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: ${MARGIN.max10};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  opacity: 0.5;
  &:hover {
    opacity: 0.8;
  }
`;

export const BackToGuidesImage = styled.img`
  margin-top: 1px;
  margin-right: 8px;
  width: 10px;
  height: 16px;
`;

export const BackToGuidesButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  display: flex;
  column-gap: ${SIZE.max10};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const PartnersCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${SIZE.max472}, 1fr));
  gap: ${SIZE.max24};
  padding-block: 0 ${SIZE.max40};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 350px), 1fr));
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const PartnersCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: ${SIZE.max24};
  padding: ${SIZE.max80};
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  border: 1px solid ${COLORS.AbsoluteWhite};
  transition: background-color 0.4s ease-out;
  cursor: pointer;
  max-height: 200px;
  min-width: 0;
  width: 100%;
  text-align: left;
  &:focus-visible { outline: 2px solid ${COLORS.Crimson}; outline-offset: 3px; }
  &:hover {
    background-color: ${COLORS.Background};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column;
    gap: 14px;
    max-height: 250px;
  }
`;

export const PartnersCardIconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const PartnersCardIcon = styled.img`
  width: 100%;
  min-height: 50px;
  width: auto;
  max-width: 160px;
  height: auto;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: ${SIZE.max110};
    width: auto;
  }
`;

export const InternationalPartnersCardIcon = styled.img`
  height: ${SIZE.max120};
  width: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const PartnersCardTextWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    -webkit-line-clamp: 2;
  }
`;

export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max220};
    width: ${SIZE.max220};
  }
`;
